import { Component, ViewEncapsulation } from '@angular/core';

import { fuseAnimations } from '../../../../../../@fuse/animations';
import { ChatChatsSidenavComponent } from './chats/chats.component';

/** Volet gauche — uniquement la liste des conversations (le sélecteur de vue
 *  user/profil de la démo a été retiré avec le fake-db). */
@Component({
  selector: 'chat-left-sidenav',
  templateUrl: './left.component.html',
  styleUrls: ['./left.component.scss'],
  standalone: true,
  imports: [ChatChatsSidenavComponent],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class ChatLeftSidenavComponent {}
